import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@pg-env/environment';

@Injectable({
  providedIn: 'root'
})
export class StatementReportService {
  public api: string;

  constructor(private http: HttpClient) {
    this.api = environment.customerApiUrl + '/client-report';
  }

  public getStatementTradeSettled(body: any): Observable<any> {
    return this.http.get(`${this.api}/get-client-statement-trades-settled?fromDate=${body.fromDate}&toDate=${body.toDate}`);
  }

  public getStatementTradeOpen(body: any): Observable<any> {
    return this.http.get(`${this.api}/get-client-statement-trades-open?fromDate=${body.fromDate}&toDate=${body.toDate}`);
  }

  public getStatementBalance(body: any): Observable<any> {
    return this.http.get(`${this.api}/get-client-statement-balances?fromDate=${body.fromDate}&toDate=${body.toDate}&includeUnverifiedTrade=${body.includeUnverifiedTrade}`);
  }

  public getStatementOverallPosition(body: any): Observable<any> {

    return this.http.get(`${this.api}/get-client-statement-overall-positions?fromDate=${body.fromDate}&toDate=${body.toDate}`);
  }

  public exportClient(body: any): Observable<any> {
    return this.http.post(`${this.api}/export-client-statement-pdf`, body, { responseType: 'blob' });
  }

  public exportClientReportExcel(body: any): Observable<any> {
    return this.http.post(`${this.api}/export-client-statement-report-excel`, body, { responseType: 'blob' });
  }

  public exportClientReportCsv(body: any): Observable<any> {
    return this.http.post(`${this.api}/export-client-statement-report-csv`, body, {
      responseType: 'blob'
    });
  }

  public getInformationClient(): Observable<any> {
    return this.http.get(`${this.api}/get-infomation-client`);
  }

  public getColumns(param): Observable<any> {
    return this.http.post(`${this.api}/get-report-columns`, param);
  }

  public updateColumns(params): Observable<any> {
    return this.http.post<any>(`${this.api}/update-report-columns`, params);
  }

  public getStatementBreakdownForCurrency(params: any): Observable<any> {
    return this.http.get(`${this.api}/get-client-statement-balance-breakdown-for-currency?fromDate=${params.fromDate}&toDate=${params.toDate}&includeUnverifiedTrade=${params.includeUnverifiedTrade}&currencyCode=${params.currencyCode}`); 
  }
}
